// extracted by mini-css-extract-plugin
export var altaccent = "ScrollToTop-module--altaccent--59615";
export var button = "ScrollToTop-module--button--01bb7";
export var icon = "ScrollToTop-module--icon--c84a8";